import { useCallback } from "react";
import { ErrorCodes } from "src/backend/openapi/v1";

import { ItkException } from "./error-types";
import { useErrorMessageTranslationsT } from "src/translation-hooks/error-message-translations";

export const useItkException = () => {
  const errorMessageTranslationsT = useErrorMessageTranslationsT();

  const getItkExceptionMessage = useCallback(
    (exception: ItkException) => {
      switch (exception.StatusCode) {
        case ErrorCodes.ApplicationSettingMissing:
          return errorMessageTranslationsT.applicationSettingMissing;
        case ErrorCodes.DuplicateObject:
          return errorMessageTranslationsT.duplicateObject;
        case ErrorCodes.FileOperationError:
          return errorMessageTranslationsT.fileOperationError;
        case ErrorCodes.FrontEndError:
          return errorMessageTranslationsT.frontEndError;
        case ErrorCodes.GetByIdNotFound:
          return errorMessageTranslationsT.getByIdNotFound;
        case ErrorCodes.IdMismatch:
          return errorMessageTranslationsT.idMismatch;
        case ErrorCodes.InvalidObject:
          return errorMessageTranslationsT.invalidObject;
        case ErrorCodes.Mismatch:
          return errorMessageTranslationsT.mismatch;
        case ErrorCodes.NotFound:
          return errorMessageTranslationsT.notFound;
        case ErrorCodes.ObjectExpired:
          return errorMessageTranslationsT.objectExpired;
        case ErrorCodes.PermissionDenied:
          return errorMessageTranslationsT.permissionDenied;
        case ErrorCodes.PropertyNotAllowedForNewElement:
          return errorMessageTranslationsT.propertyNotAllowedForNewElement;
        case ErrorCodes.RequiredPropertyMissing:
          return errorMessageTranslationsT.requiredPropertyMissing;
        case ErrorCodes.TranslationMissing:
          return errorMessageTranslationsT.translationMissing;
        case ErrorCodes.UnhandledException:
          return errorMessageTranslationsT.unhandledException;

        default:
          return exception.Message;
      }
    },
    [errorMessageTranslationsT]
  );

  return { getItkExceptionMessage };
};
